var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"invalid-feedback d-block"},[_c('transition',{attrs:{"name":"slide-down"}},[(_vm.bag.length || _vm.error)?_c('div',[_vm._v("\n            "+_vm._s(_vm.error ? _vm.error : _vm.bag[0])+"\n        ")]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }